import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const modalsSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    addModal: (state, action) => {
      return [
        ...state,
        {
          modalType: action.payload.modalType,
          modalProps: action.payload.modalProps,
        },
      ];
    },
    removeModal: (state, action) => {
      return [...state].filter(
        (modals) => modals.modalType !== action.payload.modalType
      );
    },
  },
});

export const { addModal, removeModal } = modalsSlice.actions;

export default modalsSlice.reducer;
